import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import {
  RewriteEventDescriptionCommandInput,
  RewriteEventDescriptionCommandOutput,
  GenerateShortDescriptionCommandInput,
  GenerateShortDescriptionCommandOutput,
} from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';
import { getHttpStatusCode } from '../../utils/errorHelper';

function retryTransient(failureCount: number, error: Error): boolean {
  if (failureCount >= 2) return false;
  const status = getHttpStatusCode(error);
  return !status || status >= 500;
}

export function useRewriteEventDescription() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<
    RewriteEventDescriptionCommandOutput,
    Error,
    RewriteEventDescriptionCommandInput
  >({
    mutationKey: ['RedVelvetApi', 'ai', 'rewriteEventDescription'],
    mutationFn: (input) => client.rewriteEventDescription(input),
    retry: retryTransient,
  });
}

export function useGenerateShortDescription() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<
    GenerateShortDescriptionCommandOutput,
    Error,
    GenerateShortDescriptionCommandInput
  >({
    mutationKey: ['RedVelvetApi', 'ai', 'generateShortDescription'],
    mutationFn: (input) => client.generateShortDescription(input),
    retry: retryTransient,
  });
}
